import { render, staticRenderFns } from "./genre-grid-tile.vue?vue&type=template&id=4ef627ec&scoped=true&"
import script from "./genre-grid-tile.vue?vue&type=script&lang=js&"
export * from "./genre-grid-tile.vue?vue&type=script&lang=js&"
import style0 from "./genre-grid-tile.vue?vue&type=style&index=0&id=4ef627ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef627ec",
  null
  
)

export default component.exports